import { Box, Typography, Button as UiButton } from '@mui/material';
import { type StructuredContentDocument } from '@repo/supergraph/structuredContent/types';

export type ButtonProps = StructuredContentDocument<{
  block?: boolean;
  children: string;
  href: string;
  target: string;
  primary: boolean;
  supportsSpacing: boolean;
  buttonAnnotation?: string;
}>;

export const Button = ({ props }: ButtonProps) => {
  return (
    <Box
      sx={{
        width: props.block ? '100%' : 'max-content',
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        alignItems: 'center',
      }}
    >
      <UiButton
        href={props.href}
        target={props.target}
        fullWidth={props.block}
        variant={props.primary ? 'contained' : 'outlined'}
      >
        {props.children}
      </UiButton>
      {props.buttonAnnotation && (
        <Typography
          variant="textSmall"
          sx={{
            color: 'neutral.darker',
            textAlign: 'center',
          }}
        >
          {props.buttonAnnotation}
        </Typography>
      )}
    </Box>
  );
};
